import { useMutation } from '@tanstack/react-query';

type Request = {
  companyId: number;
  body: string;
  attachments?: File[];
};

export default function usePostCompanyChatComment() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ companyId, body, attachments }: Request) => {
      const formData = new FormData();
      formData.append('body', body);
      attachments?.forEach((file) => formData.append('attachments[]', file));

      const response = await fetch(`/agent/api/companies/${companyId}/company_chat_comments`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message || '送信に失敗しました');
      }

      return data;
    },
  });
}
